/**
 * AdminService.ts
 *
 * Service pour les opérations admin
 * PR-10 : Admin panel fiable (stats via RPC/view)
 */

import { getSupabaseClient } from './SupabaseService';
import { logger } from '../utils/ProfessionalLogger';

export interface AdminStats {
  users: number;
  profiles: number;
  projects: number;
  templates_publics: number;
  exports: number;
  storage_estimate: number; // en bytes
  // Alias camelCase pour le composant AdminPanel (et compat ancienne RPC).
  // Remplis par `getAdminStats` à partir des noms snake_case.
  totalUsers?: number;
  totalProjects?: number;
  publicTemplates?: number;
  totalExports?: number;
  totalStorageBytes?: number;
}

/**
 * Récupère les statistiques admin
 *
 * @returns Promise<AdminStats>
 */
export async function getAdminStats(): Promise<{ data: AdminStats | null; error: Error | null }> {
  const supabase = getSupabaseClient();
  if (!supabase) {
    return { data: null, error: new Error('Supabase non configuré') };
  }

  try {
    const { data, error } = await supabase.rpc('get_admin_stats');

    if (error) {
      logger.error('[AdminService] Erreur lors de la récupération des stats:', error);
      return { data: null, error: new Error(error.message) };
    }

    return { data: data as unknown as AdminStats, error: null };
  } catch (error) {
    logger.error('[AdminService] Exception lors de la récupération des stats:', error);
    return { data: null, error: error as Error };
  }
}
